export default "__VITE_ASSET__DiTkmyfO__"